import type SettingsProps from "../types/SettingsProps";

const getMdPadding = ({
  iconLeft,
  iconRight,
  fullWidth,
}: SettingsProps): string => {
  if (fullWidth) {
    return "px-4";
  }
  if (iconLeft) {
    return "ps-2 pe-4";
  }
  if (iconRight) {
    return "ps-4 pe-2";
  }
  return "px-4";
};

export default getMdPadding;
